import { render, staticRenderFns } from "./AdminSegmentExport.vue?vue&type=template&id=86041a3e&"
import script from "./AdminSegmentExport.vue?vue&type=script&lang=js&"
export * from "./AdminSegmentExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports